import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { first, takeUntil } from 'rxjs/operators';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';
import { AuthService } from '../../../_common/_service/authservice.service';
import { Subject, Subscription } from 'rxjs';
import { AuthenticationService } from '../../../_common/_service/authentication.service';

@Component({
  selector: 'app-otpverification',
  templateUrl: './otpverification.component.html',
  styleUrls: ['./otpverification.component.scss']
})
export class OtpverificationComponent implements OnInit {
  public OTPDetail: FormGroup;
  timeLeft: number = 60;
  interval: any;
  IsTimerShow = false;
  IsCallBackShow = false;
  submitted = false;

  otpsendflag = false;

  countryList: any;
  isLoggedIn = false;
  userdetail: any;
  changeMobileNo: boolean = false;

  public CountryFilterCtrl: FormControl = new FormControl();
  protected _onDestroy = new Subject<void>();
  currentUser: any;

  constructor(private fb: FormBuilder, private authService: AuthService, private tokenStorageService: TokenStorageService,
    private toastr: ToastrService, public dialog: MatDialog, public dialogRef: MatDialogRef<OtpverificationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private withouttokenService: AuthenticationService
  ) {
    this.OTPDetail = this.fb.group({
      IsdCode: [null],
      MobileNo: [null],
      Otp: [null],
      FullMobileNo: [this.data.FullMobileNo]
    })
  }

  ngOnInit() {

    this.currentUser = this.tokenStorageService.getUser();
    //if (this.isLoggedIn) {
    

    // listen for search field value changes
    this.CountryFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterCountry();
      });


    //}
  }

  get f() { return this.OTPDetail.controls; }

  //compareIsdCode(o1: any, o2: any) {
  //  if (o1 == o2)
  //    return true;
  //  else
  //    return false
  //}

  MobileNoBeforeVerified() {
    
    this.getIsdCode();
    this.changeMobileNo = true;
    this.submitted = true;
    this.f.IsdCode.setValidators([
      Validators.required
    ]);
    this.f.MobileNo.setValidators([
      Validators.required
    ]);

    this.f.IsdCode.setValue(null);
    this.f.MobileNo.setValue(null);
    this.f.FullMobileNo.setValue(null);
  }

  changeMobileNoBeforeVerified() {
    this.changeMobileNo = true;   
    if (!this.f.MobileNo.value) {
      this.toastr.error("Enter Mobile No.", 'Error');
    }
    else if (!this.f.IsdCode.value || this.f.IsdCode.value == "") {
      this.toastr.error("Select Country Code", 'Error');
    }
    else {
      var post = {

        userid: this.currentUser.userid,
        isdcode: this.f.IsdCode.value,
        mobilenno: this.f.MobileNo.value
      };

      this.authService.changeMobileNoBeforeVerified(post).subscribe((response: { apiStatus: any; apiMessage: string | undefined; }) => {
        ;
        if (response.apiStatus == true) {
          this.toastr.success(response.apiMessage, 'Success');

          this.withouttokenService.updateMessagewithouttoken(this.currentUser);
          this.dialogRef.close(true);


        } else {
          this.toastr.error(response.apiMessage, 'Error');
        }

      }, (err: any) => {
        if (err.error instanceof Error) {

          this.toastr.error(err.error, 'Error');
        } else {
          this.toastr.error(err.error, 'Error');
        }
      }
      );
    }
  };

  


 


  sendOtp() {
    
    this.submitted = true;
    if (!this.f.FullMobileNo.value) {
      this.toastr.error("Full MobileNo No.", 'Error');
    }

    //if (!this.f.MobileNo.value) {
    //  this.toastr.error("Enter Mobile No.", 'Error');
    //}
    //else if (!this.f.IsdCode.value || this.f.IsdCode.value == "") {
    //  this.toastr.error("Select Country Code", 'Error');
    //}
    else {
      //var post = {
      //  MobileNo: this.f.IsdCode.value + this.f.MobileNo.value
      //};

      var post = {
        MobileNo: this.f.FullMobileNo.value
      };

      this.authService.sendOtp(post).subscribe((response: { apiStatus: any; apiMessage: string | undefined; }) => {
        
        if (response.apiStatus == true) {
          this.IsTimerShow = true;
          this.otpsendflag = true;
          this.startTimer();

          this.toastr.success(response.apiMessage, 'Success');
        } else {
          this.toastr.error(response.apiMessage, 'Error');
        }

      }, (err: any) => {
        if (err.error instanceof Error) {

          this.toastr.error(err.error, 'Error');
        } else {
          this.toastr.error(err.error, 'Error');
        }
      }
      );
    }

  }

  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
        
        if (this.timeLeft == 0) {
          this.pauseTimer();
          this.IsCallBackShow = true;
          this.IsTimerShow = false;

        }
      } else {
        this.timeLeft = 60;
      }
    }, 1000)
  }

  pauseTimer() {
    clearInterval(this.interval);
  }

  getIsdCode() {
    
    this.submitted = true;
    this.authService.getIsdCodeSignup().subscribe((response: { isSuccess: any; result: any; Message: any; }) => {
      
      this.countryList = response;

    }, (err: any) => {
      this.toastr.error(err.error, 'Error');
    }
    );
  }



  verifyOtp() {
    
    this.submitted = false;
    //if (!this.f.IsdCode.value || this.f.IsdCode.value == "") {
    //  this.toastr.error("Select Country Code", 'Error');
    //}
    //else if (this.f.MobileNo.value.length <= 5) {
    //  this.toastr.error("Enter Mobile Number Is Invalid", 'Error');
    //}
    //else if (!this.f.MobileNo.value) {
    if (!this.f.FullMobileNo.value) {
      this.toastr.error("Full MobileNo No.", 'Error');
    }
    else if (!this.f.Otp.value || this.f.Otp.value.length <= 3) {
      this.toastr.error("Please insert four digit of OTP", 'Error');
    }
    else {
      var post = {

        Mobileno: this.f.FullMobileNo.value,
        otpNumber: parseInt(this.f.Otp.value)
      };
      this.submitted = true;
      this.authService.verifyOtp(post).subscribe((response: { apiStatus: any; apiMessage: string | undefined; }) => {
        if (response.apiStatus == true) {
          
          this.toastr.success(response.apiMessage, 'Success');

          this.withouttokenService.updateMessagewithouttoken(this.currentUser);
       
          this.dialogRef.close(true);

        } else {
          this.toastr.error(response.apiMessage, 'Error');
        }

      }, (err: any) => {
        if (err.error instanceof Error) {
          this.toastr.error(err.error, 'Error');
        } else {

          this.toastr.error(err.error, 'Error');
        }
      }
      );
    }
  }


  filterCountry() {

    if (this.CountryFilterCtrl.value) {
    //  
      return this.countryList.filter((x: { name: string; }) => x.name.toLowerCase().startsWith(this.CountryFilterCtrl.value.toLowerCase()));
    } else {
      return this.countryList;
    }
  }
  
}
